import React from 'react';
import { withRouter, Route, Switch } from 'react-router-dom';
import { TransitionGroup } from 'react-transition-group';

import Project from 'data/containers/project';
import OtherProjects from 'data/containers/otherProjects';
import { ProjectTransition, OtherProjectsTransition } from './transitions';

import './style.css';

const ProjectPage = props => {
    const locationKey = props.location.pathname.split('/')[2] || '/';
    return (
        <div className="ProjectPage">
            <TransitionGroup className="ProjectPage__project" component="div">
                <ProjectTransition key={locationKey} appear>
                    <Switch location={props.location}>
                        <Route
                            exact
                            path={`/project/:id`}
                            component={Project}
                        />
                    </Switch>
                </ProjectTransition>
            </TransitionGroup>

            <div className="ProjectPage__otherProjects">
                <div className="OtherProjects">
                    <div className="OtherProjects__title">Other work</div>
                    <TransitionGroup
                        className="OtherProjects__projects"
                        component="div"
                    >
                        <OtherProjectsTransition key={locationKey} appear>
                            <Switch location={props.location}>
                                <Route
                                    exact
                                    path={`/project/:id`}
                                    component={OtherProjects}
                                />
                            </Switch>
                        </OtherProjectsTransition>
                    </TransitionGroup>
                </div>
            </div>
        </div>
    );
};

export default withRouter(ProjectPage);



// WEBPACK FOOTER //
// ./src/components/templates/projectPage/index.js